var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 55,
    x2: 171.017,
    xlinkHref: "#lg1",
    y1: 302.102,
    y2: 302.102
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2509,
    stopColor: "#f02818",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6394,
    stopColor: "#da2721",
    stopOpacity: 0.639
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.671,
    x2: 121.671,
    xlinkHref: "#lg2",
    y1: 345.051,
    y2: 474.299
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.671,
    x2: 121.671,
    xlinkHref: "#lg1",
    y1: 426.551,
    y2: 455.979
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.405,
    x2: 176.905,
    xlinkHref: "#lg2",
    y1: 405.623,
    y2: 265.123
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 347,
    x2: 440.086,
    xlinkHref: "#lg3",
    y1: 302.102,
    y2: 302.102
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.994,
    x2: 291.327,
    y1: 329.135,
    y2: 293.801
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1113,
    stopColor: "#ee2818",
    stopOpacity: 0.111
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4484,
    stopColor: "#d52724",
    stopOpacity: 0.448
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7545,
    stopColor: "#c5272b",
    stopOpacity: 0.755
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.33,
    x2: 388.33,
    xlinkHref: "#lg4",
    y1: 349.051,
    y2: 440.462
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.33,
    x2: 388.33,
    xlinkHref: "#lg3",
    y1: 426.551,
    y2: 455.979
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#62dbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08a9f1"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 196,
    x2: 325.062,
    xlinkHref: "#lg5",
    y1: 148.928,
    y2: 148.928
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 269,
    x2: 269,
    y1: 191.877,
    y2: 321.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017bae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6303,
    stopColor: "#02678e",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025f80"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 269,
    x2: 269,
    xlinkHref: "#lg5",
    y1: 273.377,
    y2: 302.805
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.715,
    x2: 308.215,
    xlinkHref: "#lg4",
    y1: 462.098,
    y2: 427.098
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.14,
    x2: 288.143,
    y1: 404.654,
    y2: 469.656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5908,
    stopColor: "#af66da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6764,
    stopColor: "#a660cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    stopColor: "#8d51b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6f3f8a"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 456.978,
    y2: 501.185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f3f8a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f3f8a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m168.705 153.174h-94.069c-20.317 0-37.308 15.439-39.248 35.663l-23.59 245.898c-.838 8.736 6.03 16.295 14.807 16.295h190.131c8.776 0 15.645-7.559 14.807-16.295l-23.59-245.898c-1.941-20.224-18.931-35.663-39.248-35.663z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.798 434.735c-.838 8.736 6.03 16.295 14.807 16.295h190.131c8.776 0 15.645-7.559 14.807-16.295l-12.825-133.684h-194.095z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.376 461.69-205.432-.036c-10.468-.005-18.95-8.496-18.944-18.964.006-10.468 8.496-18.95 18.965-18.945l205.432.036c10.468.006 18.95 8.496 18.945 18.965-.007 10.468-8.497 18.95-18.966 18.944z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m218.073 294.333h-64.865v8.834l72.686 72.685z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m435.364 153.174h-94.068c-20.317 0-37.308 15.439-39.248 35.663l-23.59 245.898c-.838 8.736 6.03 16.295 14.807 16.295h190.131c8.776 0 15.645-7.559 14.807-16.295l-23.59-245.898c-1.942-20.224-18.932-35.663-39.249-35.663z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.4 451.03h-190.14c-8.77 0-15.64-7.56-14.8-16.29l23.59-245.9c1.94-20.23 18.93-35.67 39.25-35.67h25.2l115.8 115.8 15.9 165.77c.84 8.73-6.03 16.29-14.8 16.29z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.457 434.735c-.838 8.736 6.03 16.295 14.807 16.295h190.131c8.776 0 15.645-7.559 14.807-16.295l-12.825-133.684h-194.095z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.035 461.69-205.432-.036c-10.468-.006-18.95-8.496-18.945-18.965.006-10.468 8.496-18.95 18.965-18.945l205.432.036c10.468.006 18.95 8.496 18.945 18.965-.006 10.469-8.496 18.951-18.965 18.945z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m316.034 0h-94.068c-20.317 0-37.308 15.439-39.248 35.663l-23.59 245.898c-.838 8.736 6.03 16.295 14.807 16.295h190.131c8.776 0 15.645-7.559 14.807-16.295l-23.59-245.898c-1.941-20.224-18.932-35.663-39.249-35.663z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.128 281.561c-.838 8.736 6.03 16.295 14.807 16.295h190.131c8.776 0 15.645-7.559 14.807-16.295l-12.825-133.684h-194.095z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.706 308.516-205.432-.036c-10.468-.006-18.95-8.496-18.945-18.965.006-10.468 8.496-18.95 18.965-18.945l205.432.036c10.468.006 18.95 8.496 18.944 18.965-.005 10.469-8.496 18.951-18.964 18.945z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m383.172 461.672-70.172-70.172h-11.75v70.157z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 436.513,
    fill: "url(#SVGID_13_)",
    r: 73.487
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.675 441.164c2.402 38.417 34.303 68.836 73.325 68.836s70.923-30.419 73.325-68.836z",
    fill: "url(#SVGID_14_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCups);
export default __webpack_public_path__ + "static/media/icon-cups.ddc46eee97caa4616491715639a2ce5b.svg";
export { ForwardRef as ReactComponent };